// core version + certain modules modules:
import SwiperCore, {Navigation, Pagination, Autoplay, EffectFade, Controller} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller]);

jQuery(document).ready(function ($) {

    if ($(window).width() > 767) {

        let imageSlider = new SwiperCore('.image-slider ', {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 20,
            breakpoints: {
                768: {
                    spaceBetween: 80
                }
            }
        });

    }
});
